const message_EN = {
    "data": [
        {
            "code": 500000,
            "message": "Internal system error"
        },
        {
            "code": 500001,
            "message": "Referall not found"
        },
        {
            "code": 500002,
            "message": "Payment Error"
        },
        {
            "code": 500003,
            "message": "Error in Exchange Currencies"
        },
        {
            "code": 500004,
            "message": "PaymentMethod Not Found"
        },
        {
            "code": 500005,
            "message": "PaymentGateway Not Found"
        },
        {
            "code": 500006,
            "message": "Plan Not Found"
        },
        {
            "code": 500007,
            "message": "Amount is null or Zero"
        },
        {
            "code": 500008,
            "message": "Amount is null or insufficient balance in Wallet"
        },
        {
            "code": 500009,
            "message": "Special Customer can not be referall"
        },
        {
            "code": 500010,
            "message": "Id of Plan must be Business Partner"
        },
        {
            "code": 500011,
            "message": "User Referall not found"
        },
        {
            "code": 500012,
            "message": "User not found"
        },
        {
            "code": 500013,
            "message": "Fail in attempt to authenticate user"
        },
        {
            "code": 500014,
            "message": "Error in decode JWT Token"
        },
        {
            "code": 500015,
            "message": "This JWT token does not belongs to the user in request"
        },
        {
            "code": 500016,
            "message": "Username is not available"
        },
        {
            "code": 500017,
            "message": "There is an existing account associated with this email"
        },
        {
            "code": 500018,
            "message": "Field Currency is empty or null"
        },
        {
            "code": 500019,
            "message": "Error in upload File"
        },
        {
            "code": 500020,
            "message": "Transfer payment could not be confirmed"
        },
        {
            "code": 500021,
            "message": "Special Customer can not transfer ExtraCoin"
        },
        {
            "code": 500022,
            "message": "Insufficient Balance in ExtraCoin Wallet"
        },
        {
            "code": 500023,
            "message": "Insufficient Balance in Wallet"
        },
        {
            "code": 500024,
            "message": "There is an existing account associated with this Document Number"
        },
        {
            "code": 500025,
            "message": "This E-mail does not corresponds to this user"
        },
        {
            "code": 500026,
            "message": "User plan not found"
        },
        {
            "code": 500027,
            "message": "Invalid Voucher"
        },
        {
            "code": 500028,
            "message": "Voucher Payment is valid only to Area Manager Register"
        },
        {
            "code": 500029,
            "message": "id of transaction not found"
        },
        {
            "code": 500030,
            "message": "This transaction does not belongs to this user"
        },
        {
            "code": 500031,
            "message": "This transaction is not pending of tranfer confirmation"
        },
        {
            "code": 500032,
            "message": "Category not found with correspondent id"
        },
        {
            "code": 500033,
            "message": "Attribute not found with correspondent id"
        },
        {
            "code": 500034,
            "message": "The Attribute id does not correspondent to the user in request"
        },
        {
            "code": 500035,
            "message": "SpecialCostumer can not create products"
        },
        {
            "code": 500036,
            "message": "Subcategory not found"
        },
        {
            "code": 500037,
            "message": "Product not found"
        },
        {
            "code": 500038,
            "message": "The Product id does not to the user in request"
        },
        {
            "code": 500039,
            "message": "The Product is already associated correspondent to this Attribute"
        },
        {
            "code": 500040,
            "message": "Amount minimum to create a cupom is 50"
        },
        {
            "code": 500042,
            "message": "Coupon is invalid"
        },
        {
            "code": 500043,
            "message": "The coupon does not belongs to the referall user"
        },
        {
            "code": 500044,
            "message": "Special Customer can not create coupons"
        },
        {
            "code": 500045,
            "message": "The Product is not associated to this Attribute"
        },
        {
            "code": 500046,
            "message": "The Product has already variations registered"
        },
        {
            "code": 500047,
            "message": "You can not create a variation with same attibutes"
        },
        {
            "code": 500048,
            "message": "All attributes must have at least one value assigned"
        },
        {
            "code": 500049,
            "message": "Brand is not associate to the subcategory"
        },
        {
            "code": 500050,
            "message": "Field subcategory not found"
        },
        {
            "code": 500051,
            "message": "Brand not found"
        },
        {
            "code": 500052,
            "message": "Type is not associate to the subcategory"
        },
        {
            "code": 500053,
            "message": "Type not found"
        },
        {
            "code": 500054,
            "message": "GenderProduct is not associate to the subcategory"
        },
        {
            "code": 500055,
            "message": "GenderProduct not found"
        },
        {
            "code": 500056,
            "message": "Product Variation not found"
        },
        {
            "code": 500057,
            "message": "Product may have only 2 attributes"
        },
        {
            "code": 500058,
            "message": "Product does not have any attribute registered"
        },
        {
            "code": 500059,
            "message": "This product has variations. You can not set amount total"
        },
        {
            "code": 500060,
            "message": "This variation does not corresponds to this product"
        },
        {
            "code": 500061,
            "message": "Field Language is empty or null"
        },
        {
            "code": 500062,
            "message": "The order must have at least one item"
        },
        {
            "code": 500063,
            "message": "Status permitted: PUBLISHED or UNPUBLISHED"
        },
        {
            "code": 500064,
            "message": "Buyer and Seller must be differents"
        },
        {
            "code": 500065,
            "message": "Order not found"
        },
        {
            "code": 500066,
            "message": "This order does not belongs to this user"
        },
        {
            "code": 500067,
            "message": "The product in the item does not belongs to the order seller"
        },
        {
            "code": 500068,
            "message": "Item not found in the Order"
        },
        {
            "code": 500069,
            "message": "This product has variations, please specify a idvariation"
        },
        {
            "code": 500070,
            "message": "Percent of extracoin must be between 50% and 97% for Business Partners"
        },
        {
            "code": 500071,
            "message": "Percent of extracoin must be between 10% and 97% for Area Managers"
        },
        {
            "code": 500072,
            "message": "Extracoin percentage is above what is requested by the seller"
        },
        {
            "code": 500073,
            "message": "The sum of Extracoin + Wallet + Cash must be equal to the order total"
        },
        {
            "code": 500074,
            "message": "Out of stock -> Produto"
        },
        {
            "code": 500075,
            "message": "Unable to modify/delete an item from an order that is not open"
        },
        {
            "code": 500076,
            "message": "The maximum possible extracoin amount has been exceeded. Please review your order!"
        },
        {
            "code": 500077,
            "message": "This user is not the seller of this order"
        },
        {
            "code": 500078,
            "message": "This order can not be sent"
        },
        {
            "code": 500079,
            "message": "This user is not the buyer of this order"
        },
        {
            "code": 500080,
            "message": "This order can not be received"
        },
        {
            "code": 500081,
            "message": "Career not found"
        },
        {
            "code": 500082,
            "message": "The origin Wallet has insufficient balance in Wallet to pay the fee"
        },
        {
            "code": 500083,
            "message": "The destiny Wallet has insufficient balance in Wallet to pay the fee"
        },
        {
            "code": 500084,
            "message": "The origin Wallet Extracoin has insufficient balance in Wallet to transfer"
        },
        {
            "code": 500085,
            "message": "The destiny Wallet Extracoin has insufficient balance in Wallet to transfer"
        },
        {
            "code": 500086,
            "message": "Transfer ID not found"
        },
        {
            "code": 500087,
            "message": "This user has no relationship with this Transfer"
        },
        {
            "code": 500088,
            "message": "User origin and destiny are the same"
        },
        {
            "code": 500089,
            "message": "Confirmation transfer code is not correct"
        },
        {
            "code": 500090,
            "message": "The origin user still not confirmed the transaction"
        },
        {
            "code": 500091,
            "message": "You can only rate orders that you tagged as received"
        },
        {
            "code": 500092,
            "message": "You have already rated this order"
        },
        {
            "code": 500093,
            "message": "Rates must be between 1 and 5"
        },
        {
            "code": 500094,
            "message": "Current password is incorrect"
        },
        {
            "code": 500095,
            "message": "The new password must be different from the current password"
        },
        {
            "code": 500096,
            "message": "Phone confirmation token not found"
        },
        {
            "code": 500097,
            "message": "This phone number is already confirmed"
        },
        {
            "code": 500098,
            "message": "Invalid code - confirmation phone number"
        },
        {
            "code": 500099,
            "message": "Only Special Customers can upgrade to Area Manager"
        },
        {
            "code": 500100,
            "message": "There is already a payment associated to this transactionid"
        },
        {
            "code": 500101,
            "message": "The payment transaction could not be confirmed"
        },
        {
            "code": 500102,
            "message": "Only Special Customers can upgrade to Business Partner"
        },
        {
            "code": 500103,
            "message": "User is not active. You can not request withdraws."
        },
        {
            "code": 500104,
            "message": "The sender user does not have relation with this order"
        },
        {
            "code": 500105,
            "message": "The receiver user does not have relation with this order"
        },
        {
            "code": 500106,
            "message": "Chat message not found"
        },
        {
            "code": 500107,
            "message": "User is not the receiver of this Chat message"
        },
        {
            "code": 500108,
            "message": "This user may not see the messages of this order"
        },
        {
            "code": 500109,
            "message": "This profile can not indicate a Sale Promoter"
        },
        {
            "code": 500110,
            "message": "Id of Plan must be Sale Promoter"
        },
        {
            "code": 500111,
            "message": "Sale Promoter can not create products"
        },
        {
            "code": 500112,
            "message": "Admin can not create products"
        },
        {
            "code": 500113,
            "message": "User does not have admin (superuser) permission"
        },
        {
            "code": 500114,
            "message": "Field latitude/longitude are required"
        },
        {
            "code": 500115,
            "message": "Field origin of register is required"
        },
        {
            "code": 500116,
            "message": "If the product is downloadable, you must supply the fields downloadtype, urldownload and urldownloadsample"
        },
        {
            "code": 500117,
            "message": "If at least one item is a downloadable product, all the items must be downloadable"
        },
        {
            "code": 500118,
            "message": "This order does not have downloadable items"
        },
        {
            "code": 500119,
            "message": "This device is already registered"
        },
        {
            "code": 500120,
            "message": "This device is not registered"
        },
        {
            "code": 500121,
            "message": "This device does not belongs to this user"
        },
        {
            "code": 500122,
            "message": "Product downloadable can not create variations"
        },
        {
            "code": 500123,
            "message": "Product downloadable can not receive attributes"
        },
        {
            "code": 500124,
            "message": "Violated minimum withdraw allowed"
        },
        {
            "code": 500125,
            "message": "Only Area Managers can create products with technical informations"
        },
        {
            "code": 500126,
            "message": "Technical Information id not found"
        },
        {
            "code": 500127,
            "message": "Fields weight, height, width or length not found"
        },
        {
            "code": 500128,
            "message": "This product has already been favorited by this user"
        },
        {
            "code": 500129,
            "message": "This product has not been favorited by this user"
        },
        {
            "code": 500130,
            "message": "Withdraw not found"
        },
        {
            "code": 500131,
            "message": "This withdraw has been already processed"
        },
        {
            "code": 500132,
            "message": "This user is already blocked"
        },
        {
            "code": 500133,
            "message": "This user is already unblocked"
        },
        {
            "code": 500134,
            "message": "Search not found"
        },
        {
            "code": 500135,
            "message": "This search has been already confirmed"
        },
        {
            "code": 500136,
            "message": "There is already a Brand with this description"
        },
        {
            "code": 500137,
            "message": "This type is already associated to this subcategory"
        },
        {
            "code": 500138,
            "message": "This brand is already associated to this subcategory"
        },
        {
            "code": 500139,
            "message": "Marketplace configuration not found"
        },
        {
            "code": 500140,
            "message": "This product can not be shipped. Please, contact the seller."
        },
        {
            "code": 500141,
            "message": "We can not ship from this country yet."
        },
        {
            "code": 500142,
            "message": "We could not find a carrier for your order."
        },
        {
            "code": 500143,
            "message": "This seller can not ship yet"
        },
        {
            "code": 500144,
            "message": "This product can not be shipped at the moment"
        },
        {
            "code": 500146,
            "message": "Downloadable products can not be shipped"
        },
        {
            "code": 500147,
            "message": "Services can not be shipped"
        },
        {
            "code": 500148,
            "message": "This order does not have still a parcel assigned. Please wait a few minutes and try again!"
        },
        {
            "code": 500149,
            "message": "There is already a pickup booked to this parcel"
        },
        {
            "code": 500150,
            "message": "Only the seller can book a pickup"
        },
        {
            "code": 500151,
            "message": "Conversion not found"
        },
        {
            "code": 500152,
            "message": "Conversion expired"
        },
        {
            "code": 500153,
            "message": "This Conversion does not belongs to the user in request"
        },
        {
            "code": 500154,
            "message": "This conversion has been used"
        },
        {
            "code": 500155,
            "message": "This user has already registered the address. To modify, please contact support."
        },
        {
            "code": 500156,
            "message": "This order contains a service. All items must be services."
        },
        {
            "code": 500157,
            "message": "This order is not associated to a parcel."
        },
        {
            "code": 500158,
            "message": "Partners can not create more than 50 published products!"
        },
        {
            "code": 500159,
            "message": "Partners can not create more than 50 unpublished products!"
        },
        {
            "code": 500160,
            "message": "You have a trial subscription! You can not request withdrawals!"
        },
        {
            "code": 500161,
            "message": "Only Managers and Partners need to renew the subscription!"
        },
        {
            "code": 500162,
            "message": "You can only renew your subscription from 10 days before its expiration date!"
        },
        {
            "code": 500163,
            "message": "Renew can not be paid by this payment method!"
        },
        {
            "code": 500164,
            "message": "This method only can pay renewal!"
        },
        {
            "code": 500165,
            "message": "This voucher can not be used to pay this plan!"
        },
        {
            "code": 500166,
            "message": "Invalid or expired security code"
        },
        {
            "code": 500167,
            "message": "Id of Plan must be Seller"
        },
        {
            "code": 500168,
            "message": "Percent of extracoin must be between 30% and 97% for Sellers"
        },
        {
            "code": 500169,
            "message": "A product can not be service and downloadable at same time"
        },
        {
            "code": 500170,
            "message": "You are trying to add a service a order that has non-service items"
        },
        {
            "code": 500171,
            "message": "Product Question not found"
        },
        {
            "code": 500172,
            "message": "This user can not answer this question"
        },
        {
            "code": 500173,
            "message": "This question has been already answered"
        },
        {
            "code": 500174,
            "message": "You can not ask about your own product"
        },
        {
            "code": 500175,
            "message": "Notification not found"
        },
        {
            "code": 500176,
            "message": "This Notification does not belongs to the user in request"
        },
        {
            "code": 500177,
            "message": "Your notifications could not be sent because your extracoin balance is insufficient, but your product is registered correctly"
        },
        {
            "code": 500178,
            "message": "If your order has at least one item with free shipping, all items must be free shipping also"
        },
        {
            "code": 500179,
            "message": "You can not create products"
        },
        {
            "code": 500180,
            "message": "You can not upgrade to SilverPro"
        },
        {
            "code": 500181,
            "message": "You can not upgrade to GeoGold"
        },
        {
            "code": 500182,
            "message": "You can not upgrade to StartSeller"
        },
        {
            "code": 500183,
            "message": "Share Content not found"
        },
        {
            "code": 500184,
            "message": "This product has been already shared by this user"
        },
        {
            "code": 500185,
            "message": "Wallet Extrabonus not found"
        },
        {
            "code": 500186,
            "message": "This order can not be picked up at the seller address"
        },
        {
            "code": 500187,
            "message": "publicKey not found"
        },
        {
            "code": 500188,
            "message": "transactionidCrypto not found"
        },
        {
            "code": 500189,
            "message": "Payment error. We could not confirm your crypto wallet transaction."
        },
        {
            "code": 500190,
            "message": "If the product is imported, you must supply the field OriginProductImported"
        },
        {
            "code": 500191,
            "message": "If the product is imported from Banggood you must supply the field ProductIdBanggood"
        },
        {
            "code": 500192,
            "message": "This product is not assigned to this attribute"
        },
        {
            "code": 500193,
            "message": "This attribute is assigned in at least one variation! Delete the variations first!"
        },
        {
            "code": 500194,
            "message": "Edit your product and set the percent of cashback before publish"
        },
        {
            "code": 500195,
            "message": "Percent of cashback must be between 1% and 5% for Customers"
        },
        {
            "code": 500196,
            "message": "Store not found"
        },
        {
            "code": 500197,
            "message": "This Store does not belongs to this user"
        },
        {
            "code": 500198,
            "message": "Slug not available"
        },
        {
            "code": 500199,
            "message": "This order is already PAID"
        },
        {
            "code": 500200,
            "message": "This payment does not have a bank transfer associated"
        },
        {
            "code": 500201,
            "message": "PaymentPlan not found"
        },
        {
            "code": 500202,
            "message": "This PaymentPlan is already paid"
        },
        {
            "code": 500203,
            "message": "Product not available to sale"
        },
        {
            "code": 500204,
            "message": "Only store profile can use this kind of payment"
        },
        {
            "code": 500205,
            "message": "Payment not found"
        },
        {
            "code": 500206,
            "message": "Fail in authentication"
        },
        {
            "code": 500207,
            "message": "The sum of the values of the two wallets (main + extracredit) must equal the amount payable"
        },
        {
            "code": 500208,
            "message": "Your profile does not allow this operation"
        },
        {
            "code": 500209,
            "message": "Marketplace section not found"
        },
        {
            "code": 500210,
            "message": "Shop not configured yet! Configure it first."
        },
        {
            "code": 500211,
            "message": "This profile can not indicate this register"
        },
        {
            "code": 500212,
            "message": "Fringe Benefit not found"
        },
        {
            "code": 500213,
            "message": "Fringe Benefit Order not found"
        },
        {
            "code": 500214,
            "message": "Fringe Benefit Order is already paid"
        },
        {
            "code": 500215,
            "message": "This Fringe Benefit Order does not belongs to this user"
        },
        {
            "code": 500216,
            "message": "Insufficient amount of this benefit"
        },
        {
            "code": 500217,
            "message": "The sum of Extracoin + Wallet + Paypal must be the total of the Order"
        },
        {
            "code": 500218,
            "message": "There is no payment assigned to this order"
        },
        {
            "code": 500219,
            "message": "Voucher Fringe Benefit not found"
        },
        {
            "code": 500220,
            "message": "Voucher Fringe Benefit has been used"
        },
        {
            "code": 500221,
            "message": "This voucher can not be used in this seller"
        },
        {
            "code": 500222,
            "message": "Whatsapp Instance not found"
        },
        {
            "code": 500223,
            "message": "Address Not Found"
        },
        {
            "code": 500224,
            "message": "This Address does not belongs to this user"
        },
        {
            "code": 500225,
            "message": "This Order is not to pickup in the Address Store"
        },
        {
            "code": 500226,
            "message": "This Order Already to pickup in the Address Store"
        },
        {
            "code": 500227,
            "message": "Document not found"
        },
        {
            "code": 500228,
            "message": "We could not confirm your e-mail"
        },
        {
            "code": 500230,
            "message": "No password change requests found"
        },
        {
            "code": 500231,
            "message": "This password change request has already been used"
        },
        {
            "code": 500232,
            "message": "Theme customization is only permitted for Managers"
        },
        {
            "code": 500233,
            "message": "Theme not found"
        },
        {
            "code": 500234,
            "message": "This user can not customize the theme"
        },
        {
            "code": 500235,
            "message": "Invalid phone number format. Please use the international format with country code (e.g., +393471234567)."
        },
        {
            "code": 500236,
            "message": "Bank account not found or does not belong to this user"
        },
        {
            "code": 500237,
            "message": "Bank name, IBAN and account owner are required"
        },
        {
            "code": 500238,
            "message": "Whatsapp number not found or does not belong to this user or already confirmed"
        },
        {
            "code": 500239,
            "message": "This user has already a WhatsApp number associated! Please, remove it to add another number"
        },
        {
            "code": 500240,
            "message": "Only managers can create a subnet"
        },
        {
            "code": 500241,
            "message": "This user has already a subnet"
        },
        {
            "code": 500242,
            "message": "ATECO code not found"
        },
        {
            "code": 500243,
            "message": "User not authorized to remove this ATECO code"
        },
        {
            "code": 500244,
            "message": "User does not belongs to any subnet"
        },
        {
            "code": 500245,
            "message": "User already belongs to a subnet"
        },
        {
            "code": 500246,
            "message": "Complete your registration with your address or authorize the sharing of your geolocation."
        },
        {
            "code": 500247,
            "message": "This user has already a profile form filled"
        },
        {
            "code": 500248,
            "message": "Customers can not create more than 5 published products"
        },
        {
            "code": 500249,
            "message": "Customers can not create more than 5 unpublished products"
        },
        {
            "code": 500250,
            "message": "Subnet not found"
        },
        {
            "code": 500251,
            "message": "This user does not belongs to this subnet"
        },
        {
            "code": 500252,
            "message": "Store is not approved for physical store sales. Please submit your proof of physical store first."
        },
        {
            "code": 500253,
            "message": "No physical store proof found for this user"
        },
        {
            "code": 500254,
            "message": "Field reason is required for rejection"
        },
        {
            "code": 500255,
            "message": "This Store is already StartSeller"
        },
        {
            "code": 500256,
            "message": "Field physicalStoreName is required"
        },
        {
            "code": 500257,
            "message": "Field proofPhotoUrl is required"
        },
        {
            "code": 500258,
            "message": "Field physicalAddress is required"
        },
        {
            "code": 500259,
            "message": "Field physicalCity is required"
        },
        {
            "code": 500260,
            "message": "The store must accept the convention terms to proceed"
        },
        {
            "code": 500261,
            "message": "No signed convention found for this store"
        },
        {
            "code": 500262,
            "message": "Field legalRepresentativeName is required"
        },
        {
            "code": 500263,
            "message": "Field taxId (Partita IVA / C.F.) is required"
        },
        {
            "code": 500264,
            "message": "Field commercialName (Insegna) is required"
        },
        {
            "code": 500265,
            "message": "Field address is required"
        },
        {
            "code": 500266,
            "message": "Field city is required"
        },
        {
            "code": 500267,
            "message": "Field merchantCategory is required"
        },
        {
            "code": 500268,
            "message": "Store must sign the Extraconomy convention before submitting the physical store proof"
        },
        {
            "code": 500300,
            "message": "Failed to authenticate with the Aruba API (signin)"
        },
        {
            "code": 500301,
            "message": "Failed to refresh the Aruba API token (refresh)"
        },
        {
            "code": 500310,
            "message": "Could not determine the fiscal province"
        },
        {
            "code": 500311,
            "message": "User's document number is empty"
        },
        {
            "code": 500312,
            "message": "User's document number does not match either a Codice Fiscale or a Partita IVA"
        },
        {
            "code": 500313,
            "message": "This user type does not have fiscal or address data"
        },
        {
            "code": 500314,
            "message": "Incomplete registration data to issue the invoice"
        },
        {
            "code": 500315,
            "message": "Extraconomy's issuer configuration is incomplete"
        },
        {
            "code": 500320,
            "message": "This user type does not have fiscal data"
        },
        {
            "code": 500321,
            "message": "It is necessary to inform whether it is an Individual or a Legal Entity"
        },
        {
            "code": 500322,
            "message": "Invalid person type"
        },
        {
            "code": 500323,
            "message": "This user type cannot be changed to the selected type"
        },
        {
            "code": 500324,
            "message": "Fiscal name is required for Legal Entity"
        },
        {
            "code": 500325,
            "message": "First and last name are required for Individual"
        },
        {
            "code": 500326,
            "message": "Document (CF/VAT number) is required"
        },
        {
            "code": 500327,
            "message": "Address is required"
        },
        {
            "code": 500328,
            "message": "Street number is required"
        },
        {
            "code": 500329,
            "message": "Postal code is required"
        },
        {
            "code": 500330,
            "message": "City is required"
        },
        {
            "code": 500331,
            "message": "Country is required"
        },
        {
            "code": 500400,
            "message": "Automatic invoicing is blocked"
        },
        {
            "code": 500410,
            "message": "Invalid withdrawal amount (null or ≤ 0)"
        },
        {
            "code": 500411,
            "message": "Token wallet not found for the user"
        },
        {
            "code": 500412,
            "message": "Insufficient balance for the requested withdrawal"
        },
        {
            "code": 500413,
            "message": "Withdrawal request not found"
        },
        {
            "code": 500414,
            "message": "Withdrawal request had already been processed"
        },
        {
            "code": 500415,
            "message": "EXC address is required to withdraw"
        },
        {
            "code": 500416,
            "message": "Enter the verification code sent to your e-mail"
        }
    ]
}

export default message_EN;
